import { render, staticRenderFns } from "./TreatmentPlanObjectivesV1.vue?vue&type=template&id=2634b4dc&"
import script from "./TreatmentPlanObjectivesV1.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanObjectivesV1.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanObjectivesV1.vue?vue&type=style&index=0&id=2634b4dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports